import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const navItems = [
  { label: "赛事直播", to: "/" },
  { label: "赛程查询", to: "/category/2025-2026" },
  { label: "回放集锦", to: "/replays" },
  { label: "球队与球员", to: "/teams" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileSearch, setMobileSearch] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDrawerOpen(false);
    setMobileSearch(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawerOpen]);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
            <i className="ri-basketball-fill text-xl" />
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950 whitespace-nowrap">
            NBA直播吧
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 mx-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-primary-700 bg-primary-50 font-semibold"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-primary-50/60"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block w-64 ml-auto shrink-0">
          <SearchBox />
        </div>

        <div className="flex items-center gap-1 ml-auto lg:ml-0">
          <button
            type="button"
            onClick={() => setMobileSearch((prev) => !prev)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl" />
          </button>
          <button
            type="button"
            onClick={() => setDrawerOpen(true)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className="ri-menu-line text-xl" />
          </button>
        </div>
      </div>

      {mobileSearch && (
        <div className="lg:hidden border-t border-background-200 px-4 py-3">
          <SearchBox autoFocus onNavigate={() => setMobileSearch(false)} />
        </div>
      )}

      {drawerOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-foreground-950/40"
            onClick={() => setDrawerOpen(false)}
            aria-hidden="true"
          />
          <div className="absolute left-0 top-0 h-full w-72 max-w-[80%] bg-background-50 p-4 animate-slide-in">
            <div className="flex items-center justify-between mb-6">
              <span className="font-heading text-lg font-bold text-foreground-950">导航菜单</span>
              <button
                type="button"
                onClick={() => setDrawerOpen(false)}
                className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
                aria-label="关闭菜单"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-3 py-3 text-sm rounded-md transition-colors ${
                      isActive
                        ? "text-primary-700 bg-primary-50 font-semibold"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}